var render, staticRenderFns
import script from "./StartEndLocationMarker.vue?vue&type=script&lang=js&"
export * from "./StartEndLocationMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fce6e1a')) {
      api.createRecord('6fce6e1a', component.options)
    } else {
      api.reload('6fce6e1a', component.options)
    }
    
  }
}
component.options.__file = "src/pages/Map/components/StartEndLocationMarker.vue"
export default component.exports